import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';

// Based on the actual API response structure
export interface ConsentData {
  id: string;
  member_id: string;
  communication_preferences: {
    email: boolean;
    sms: boolean;
    whatsapp: boolean;
    phone_calls: boolean;
  };
  content_types: {
    appointment_reminders: boolean;
    health_education: boolean;
    programme_invites: boolean;
    feedback_surveys: boolean;
  };
  created_at: string;
  updated_at: string;
  status: string;
}

export interface ConsentHistoryItem {
  id: string;
  field_name: string;
  previous_value: string;
  new_value: string;
  changed_at: string;
}

export interface ConsentHistoryResponse {
  member_id: string;
  history: ConsentHistoryItem[];
  total_count: number;
  status: string;
}

export interface UpdateConsentRequest {
  communication_preferences?: {
    email?: boolean;
    sms?: boolean;
    whatsapp?: boolean;
    phone_calls?: boolean;
  };
  content_types?: {
    appointment_reminders?: boolean;
    health_education?: boolean;
    programme_invites?: boolean;
    feedback_surveys?: boolean;
  };
}

// GET - Retrieve consent data for a specific member
export const getMemberConsent = async (
  member_id: string
): Promise<ConsentData> => {
  try {
    const url = `${API_V1_PREFIX}consent/member/${member_id}`;
    console.log('consent.ts: Making API call to:', url);
    console.log('consent.ts: API_V1_PREFIX value:', API_V1_PREFIX);
    console.log('consent.ts: member_id value:', member_id);
    
    const { data } = await axiosInstance.get(url);

    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error(error);
  }
};

// PUT - Update consent data for a specific member
export const updateMemberConsent = async (
  member_id: string,
  consentData: UpdateConsentRequest
): Promise<ConsentData> => {
  try {
    const { data } = await axiosInstance.put(
      `${API_V1_PREFIX}consent/member/${member_id}`,
      consentData
    );

    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error(error);
  }
};

// GET - Retrieve consent history for a specific member
export const getMemberConsentHistory = async (
  member_id: string,
  limit: number = 50,
  offset: number = 0
): Promise<ConsentHistoryResponse> => {
  try {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    const requestUrl = `${API_V1_PREFIX}consent/member/${member_id}/history?${params.toString()}`;
    
    console.log('consent.ts: Making change history API call to:', requestUrl);
    console.log('consent.ts: API_V1_PREFIX value:', API_V1_PREFIX);
    console.log('consent.ts: member_id value:', member_id);

    const { data } = await axiosInstance.get(requestUrl);
    
    console.log('consent.ts: Change history API response:', data);

    return data;
  } catch (error: any) {
    console.error('consent.ts: Change history API error:', error);
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    }
    throw new Error(error);
  }
};